// ──────────────────────────────────────────────
// React hooks for UploadService.
// Use useSyncExternalStore for tear-free reads.
// ──────────────────────────────────────────────

import { useSyncExternalStore } from 'react';

import type { UploadService } from './UploadService';
import type { UploadState } from './types';

// ── Fallback snapshot (returned when service is null) ──

const IDLE_UPLOAD: UploadState = {
  status: 'idle',
  queueDepth: 0,
  inFlightCount: 0,
  completedCount: 0,
  failedCount: 0,
  bytesUploaded: 0,
  totalBytes: 0,
  isOnline: true,
  isDraining: false,
  deadLetterQueue: [],
};

const noop = () => () => {};

/**
 * Subscribe to UploadService state.
 * Returns a static idle state when service is null.
 */
export function useUploadState(service: UploadService | null): UploadState {
  return useSyncExternalStore(
    service ? (cb) => service.subscribe(cb) : noop,
    service ? () => service.getSnapshot() : () => IDLE_UPLOAD,
  );
}
